import { FC } from "react";

type Props = { children: string };

const Label: FC<Props> = ({ children }) => (
  <span className="block text-xs font-medium text-gray-500">{children}</span>
);

export default Label;
